// @flow
// TODO: prop spread can be avoided. Refactor needed
import * as React from 'react';
import { Box, Flex, Text, defaultTheme } from '@locus-taxy/neo-ui';

const Title = props => {
    const { value } = props;

    return <Box>{value}</Box>;
};

/** TooltipItem.Value<PureComponent> */
const Value = props => {
    const { value } = props;
    return <Box>{value}</Box>;
};

class TooltipItem extends React.PureComponent {
    static Title = Title;
    static Value = Value;

    render() {
        const { children, inline, ...rest } = this.props;
        const styles = inline
            ? {
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center'
              }
            : {
                  flexDirection: 'column'
              };

        return (
            <Flex {...rest} {...styles} mt={2}>
                {children}
            </Flex>
        );
    }
}

const TooltipSection = props => {
    const { children, ...others } = props;

    return (
        <Flex {...others} pb={2} flexDirection="column">
            {children}
        </Flex>
    );
};
const SectionHeader = props => {
    const { value } = props;

    return (
        <Box mt={2}>
            <Text fontSize={1} fontWeight="bolder">
                {value}
            </Text>
        </Box>
    );
};
const TooltipHeader = props => {
    const { value, ...rest } = props;
    const borderColor = defaultTheme.colors.grey['600'];

    return (
        <Flex
            {...rest}
            pb={2}
            sx={{ borderBottom: `.5px solid ${borderColor}` }}
        >
            {value}
        </Flex>
    );
};

const TooltipBody = props => {
    const { children, flexDirection = 'column', ...rest } = props;
    const borderColor = defaultTheme.colors.grey['800'];
    return (
        <Flex
            {...rest}
            flexDirection={flexDirection}
            sx={{
                '& > div': {
                    borderBottom: `.5px solid ${borderColor}`,
                    '&:last-child': {
                        borderBottom: 'unset',
                        paddingBottom: null
                    }
                }
            }}
        >
            {children}
        </Flex>
    );
};

const TooltipContent = props => {
    const {
        children,
        justifyContent = 'center',
        flexDirection = 'column',
        padding = 3,
        ...rest
    } = props;
    return (
        <Flex
            {...rest}
            justifyContent={justifyContent}
            flexDirection={flexDirection}
            padding={padding}
        >
            {children}
        </Flex>
    );
};

export default TooltipContent;
export {
    TooltipHeader,
    TooltipBody,
    TooltipItem,
    TooltipSection,
    SectionHeader
};
